var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearchHeader = function SvgIconSearchHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#777E90",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.356 3.617A8.114 8.114 0 1 1 15.37 17.11 8.114 8.114 0 0 1 6.356 3.617m4.508.133a6.614 6.614 0 0 1 6.613 6.614M10.864 3.75a6.614 6.614 0 1 0 6.613 6.614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.827 15.327a.75.75 0 0 1 1.06 0l5.143 5.143a.75.75 0 1 1-1.06 1.06l-5.143-5.142a.75.75 0 0 1 0-1.06"
  }))));
};
export default SvgIconSearchHeader;